/**
 * Created by Balazs Foldesi on 2017. 10. 25.
 */

import { Slider } from './modules/Slider';
import { BoxHeights } from './modules/BoxHeights';
import { SWHREF } from './modules/SWHREF';
import constant from './constants/constants';
import $ from 'jquery';

export default function () {
	function resizeImg() {
		const picturetagCoverWidth = $(constant.PICTURE_TAG_SELECTOR).css('width');
		const picturetagCoverHeight = $(constant.PICTURE_TAG_SELECTOR).css('height');

		$(constant.PICTURE_TAG_SELECTOR + ' img').css({
			'min-width': picturetagCoverWidth,
			'min-height': picturetagCoverHeight
		});
	}

	$(document).ready(function () {
		setTimeout(function () {
			$(constant.SLIDER_CONTAINER_SELECTOR).each(function () {
				// eslint-disable-next-line
				new Slider(this, Object.assign({}, constant.DEVICE_CARD_SLIDER_PARAMS), constant.DEVICE_CARD_SLIDER_SELECTORS);
			});

			$(constant.BOX_HEIGHTS_CONTAINER_SELECTOR).each(function () {
				// eslint-disable-next-line
				new BoxHeights({ container: this, boxSelector: constant.BOX_HEIGHTS_TITLE_ITEM_SELECTOR });
				// eslint-disable-next-line
				new BoxHeights({ container: this, boxSelector: '.card-ps__text' });
				SWHREF.init(this);
			});

			$(constant.MD_PANEL_SELECTOR).each(function () {
				SWHREF.init(this);
			});
		});

		resizeImg();

		$(window).on('resize', function () {
			resizeImg();
		});

		let hashParam = window.location.hash.replace('#', '');
		let campaignBoxes = $(constant.CAMPAIGN_BOX);
		let defaultCampaignBoxes = $(constant.DEFAULT_CAMPAIGN_BOX);
		let hashParamMathed = false;

		if (campaignBoxes && hashParam) {
			campaignBoxes.each(function () {
				if ($(this).attr('id') && $(this).attr('id') === hashParam) {
					$(this).removeClass('cloak');
					hashParamMathed = true;
				}
			});
		}

		if (!hashParamMathed) {
			defaultCampaignBoxes.each(function () {
				$(this).removeClass('cloak');
			});
		}
	});
}
